import { render } from "./ContentBuilderDataGenerator.vue?vue&type=template&id=9a08c6f0"
import script from "./ContentBuilderDataGenerator.vue?vue&type=script&lang=js"
export * from "./ContentBuilderDataGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__